/**
 * CodeIcon/index.js
 * desc: system icon for code step type
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const CodeIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="code icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.code.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 22 14" xmlns="http://www.w3.org/2000/svg"><path d="M3.08 6.6l5.06 5.06L6.6 13.2 0 6.6 6.6 0l1.54 1.54L3.08 6.6zm15.84 0l-5.06 5.06 1.54 1.54L22 6.6 15.4 0l-1.54 1.54 5.06 5.06z"/></svg>
    </IconButton>
);


export default CodeIcon;
